
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.241 5.44A9.325 9.325 0 0023.6 2.687l-.095.001A9.546 9.546 0 0016.756 5.5L3.157 19.098C.324 21.932.275 26.493 3.048 29.266a6.992 6.992 0 004.984 2.048 7.288 7.288 0 005.183-2.157L26.87 15.503a5.19 5.19 0 001.533-3.623 4.995 4.995 0 00-5.02-5.09c-1.389 0-2.7.545-3.691 1.535L7.423 20.594a1.263 1.263 0 00.895 2.162c.337 0 .655-.131.895-.371l12.269-12.27a2.672 2.672 0 011.9-.795 2.48 2.48 0 011.767.723c.473.472.727 1.112.719 1.802a2.678 2.678 0 01-.791 1.864L11.423 27.365a4.773 4.773 0 01-3.392 1.417 4.476 4.476 0 01-3.192-1.308c-1.785-1.786-1.737-4.74.109-6.585l.59-.59.052-.026.025-.05L18.547 7.291a7.024 7.024 0 014.966-2.07c1.899.012 3.653.727 4.937 2.011a6.876 6.876 0 012.018 4.938 7.04 7.04 0 01-2.079 4.966L17.722 27.802a1.263 1.263 0 000 1.791c.239.239.558.371.895.371.339 0 .657-.132.896-.371l10.668-10.667c3.735-3.734 3.762-9.784.06-13.486z"}})])
          )
        }
      }
    